<template>
    <div class="team-lesson">
        <el-dialog
            class="coach-lesson-dialog"
            :visible.sync="visible"
            :title="$t('Sell.Buy.single_buy')"
            left>
            <div class="flex pay-setting items-center">
                <div>{{ $t('Sell.Buy.support') }}</div>
            </div>
            <div class="pay-setting">{{ $t('Sell.Buy.support_personal') }}</div>
            <div class="pay-content">
                <el-table :data="form"
                    ref="multipleTable"
                    border style="width: 100%;"
                    v-loading="loading"
                    @selection-change="handleSelectChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column :label="$t('Lesson.personal')">
                        <template slot-scope="{row}">{{ row.name }}</template>
                    </el-table-column>
                    <el-table-column prop="name" :label="$t('Card.pay_one')" >
                        <template slot-scope="{row, $index}">
                            <el-input type="number" v-model="row.rate"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="handle-setAll flex items-center">
                <div>{{ $t('Sell.Dialog.set_price') }}</div>
                <el-input class="setAll-input" type="number" v-model.number="price"></el-input>
                <div @click="handlePrice" class="save-btn">{{ $t('Common.save') }}</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">{{ $t('Common.close') }}</el-button>
                <el-button @click="confirm" type="primary">{{ $t('Message.confirm') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Table, Dialog, TableColumn, Form} from 'element-ui';

export default {
    name: 'coach-lesson',
    components: {
        ElTable: Table,
        ElDialog: Dialog,
        ElTableColumn: TableColumn,
        ELForm: Form,
    },
    data() {
        return {
            visible: false,
            loading: false,
            form: [],
            rate: null,
            rates: [],
            storedCardId: null,
            price: null,
            coachLesson: {},
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            // 清空数据
            this.storedCardId = null;
            this.form = [];
            this.rates = [];
            this.price = null;
        },
        open(data) {
            this.storedCardId = data;
            this.fetchCoachList();
        },
        handleSelectChange(val) {
            this.rates = val;
        },
        fetchCoachList() {
            API.get('stored-value-card/coach-lesson').then(res => {
                if (!res || !res.length) return $ele.$message.warning('当前无支持储值卡单次购买的私教课程!');
                this.visible = true;
                res = res.map(el => {
                    el = Object.assign({}, el, {rate: 0});
                    return el;
                });
                this.form = res;
                this.fetchCoachLesson(this.storedCardId);
            });
        },
        async fetchCoachLesson() {
            let data = null;
            await API.get(`stored-value-card/${this.storedCardId}/coach-lesson/rate`)
            .then(res => {
                this.coachLesson = res;
                data = res;
            });
            if (data.rates && data.rates.length) {
                let rows = [];
                this.form = this.form.map(el => {
                    data.rates.forEach(item => {
                        if (item.lessonId === el.id) {
                            el = Object.assign({}, el, {rate: Number(item.rate)});
                            rows.push(el);
                        }
                    });
                    return el;
                });
                this.$nextTick(() => {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                });
            }
        },
        handlePrice() {
            this.form.forEach(el => {
                this.rates.map(item => {
                    if (item.id === el.id) {
                        el.rate = this.price;
                    }
                });
            });
        },
        confirm() {
            const rates = this.rates.map(el => {
                el.lessonId = el.id;
                delete el.name;
                delete el.id;
                return el;
            });
            // 确定
            API.put(`stored-value-card/${this.storedCardId}/coach-lesson/rate`, {
                rates: rates,
            }).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.$emit('fetchData');
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.coach-lesson-dialog {
    .el-dialog {
        width: 540px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 88vh;
        overflow-y: auto;
    }
}
.pay-setting {
    margin: 0 0 20px 0;
    font-size: 12px;
}
.el-dialog--center .el-dialog__body {
    padding: 25px 25px 0 25px;
}
.handle-setAll {
    width: 100%;
    padding: 10px;
    border: 1px solid #e6e6e6;
    border-top: none;
    color: grey;
    background: #f7f7f7;
    font-size: 12px;
}
.setAll-input {
    width: 120px;
    margin: 0 10px;
}
.save-btn {
    color: #05abef;
}
</style>
